
import { IConfig } from '../models/config-model';
import IFilter from '../models/filter-model';
import IPanel from '../models/panel-model';
import { PanelFilterWidgetService } from '../services/panel-filter-widget-services'

export class State {
  config: IConfig = {codename:'', apibaseurl: '', language: ''}; 

  labels: {} = {};
 
  // Search results
  totalResults: number = 0;

  // Filters
  filters: IFilter[] = [];
  detailFilter?: IFilter;
  showDetailFilter: boolean = false;

  //Panels
  panels: IPanel[] =[];
  detailPanel?: IPanel;
  showDetailPanel: boolean = false;

  // States
  loading: boolean = false;
  initialLoad: boolean = true;
  
  //services
  panelFilterWidgetService!: PanelFilterWidgetService;

  error?:string;
} 
